import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost } from "./apiClient";

// Transaction list and details
export const getTransactionsAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/transactions/list`, payload, opts);

export const getTransactionDetailsAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/transactions/details`, payload, opts);

// Vendor statement (GET with query params: from_date, to_date, type, page, limit)
export const getVendorStatementAPI = (params, opts) =>
  apiGet(`${BE_ADMIN_BASE}/vendor-statement`, { ...opts, params });
